
import React from "react";
// import img1 from "./imgs/5-R-Smart Pro-c.jpg";
import {DEFAULT_LOCALE, LOCALES_HELPER} from "../../../../locales/config";
// import img1en from "./imgs/5-R-Smart Pro.jpg";

export function RSmartPro() {

    const lang = LOCALES_HELPER.getLan();

    return (
        <>
            {lang === DEFAULT_LOCALE
                ? <>
                </>
                : <>
                    {/* <img className="product-img" src={img1en}/> */}
                </>
            }
        </>
    )
}